/**
 * Names of goal types (in the GoalTypes table) that classify a fund expense.
 * Both goals share AllowedFor.Fund; the distinction is purely the expense classification
 * (regular fund expense vs. fundraising expense), which drives the eligibility limit
 * for fundraising expenses (see FundExpenseLimits on the backend).
 *
 * Keep in sync with WebApi/Models/Common/FundExpenseGoalNames.cs.
 */
export const FUND_EXPENSE_GOAL_NAMES = {
  REGULAR: 'FundExpenses',
  FUNDRAISING: 'FundraisingExpenses',
} as const;

export type FundExpenseGoalName = (typeof FUND_EXPENSE_GOAL_NAMES)[keyof typeof FUND_EXPENSE_GOAL_NAMES];

/**
 * Returns true if the goal name represents a fundraising-expense goal (subject to limit).
 */
export const isFundraisingExpenseGoalName = (goalName: string | undefined | null): boolean =>
  goalName === FUND_EXPENSE_GOAL_NAMES.FUNDRAISING;
